import { MatCalendarCellCssClasses } from '@angular/material/datepicker';
import dayjs from 'dayjs';

export class MonthYearsHelpers {
    static prepareValidMonths(): number[] {
        const validMonths = [];
        for (let i = 1; i <= 12; i++) {
            if (i < 10) {
                validMonths.push(`0${i}`);
            } else {
                validMonths.push(i.toString());
            }
        }
        return validMonths;
    }

    static prepareValidYears(): number[] {
        const year = new Date().getFullYear();
        const validYears = [];
        for (let i = 0; i < 100; i++) {
            validYears.push(year - i);
        }
        return validYears;
    }
}

export class HttpResponseHelpers {
    static parseErrorResponse(err: any): string {
        let errorMsg = '';
        let index = 0;
        const errorLength = Object.entries(err?.error?.errors ?? []).length;

        if (errorLength) {
            for (const errorVal of Object.values(err.error.errors)) {
                if (index > 0) {
                    errorMsg += ',\n';
                }
                errorMsg += `${Object.keys(err.error.errors)[index]}: ${errorVal}`;
                index++;
            }
        } else {
            errorMsg = err.error?.error_description ?? err.error ?? 'Unknown error occurred.';
        }

        return errorMsg;
    }
}

export class RtoDatesHelpers {
    static shouldDisplayRTOAlertOnStartOrEndDate(
        startDate: Date | null,
        endDate: Date | null,
        vacationDays: Date[] | null
    ): boolean {
        if (!startDate || !endDate || !vacationDays?.length) {
            return false;
        }
        const startDateTime = RtoDatesHelpers.convertToTimestamp(startDate);
        const endDateTime = RtoDatesHelpers.convertToTimestamp(endDate);

        return vacationDays.some((date) => {
            const vacationDateTime = RtoDatesHelpers.convertToTimestamp(date);
            return vacationDateTime === startDateTime || vacationDateTime === endDateTime;
        });
    }

    static getCssClassForDate(
        date: Date,
        offerStartDate: Date,
        offerEndDate: Date,
        daysSelected: any[]
    ): MatCalendarCellCssClasses {
        const dateSelected = 'date-selected';
        const dateContractStartEndClass = 'date-contract-start-or-end';
        if (!daysSelected || daysSelected.length === 0) {
            return '';
        }
        const foundDate = daysSelected.find((value) => RtoDatesHelpers.convertToTimestamp(value) === date.getTime());
        if (foundDate) {
            if (RtoDatesHelpers.addCssClassForOfferStartEndDates(date, offerStartDate, offerEndDate)) {
                return dateContractStartEndClass;
            }
            return dateSelected;
        }
        return null;
    }

    static convertToTimestamp(date: string | Date): number {
        return dayjs(date).toDate().getTime();
    }

    static addCssClassForOfferStartEndDates(event: Date, offerStartDate: Date, offerEndDate: Date): boolean {
        if (event === null || event === undefined || !offerStartDate || !offerEndDate) {
            return false;
        }
        const selectedDateTime = RtoDatesHelpers.convertToTimestamp(event);
        const offerStartDateTime = offerStartDate ? RtoDatesHelpers.convertToTimestamp(offerStartDate) : 0;
        const offerEndDateTime = offerEndDate ? RtoDatesHelpers.convertToTimestamp(offerEndDate) : 0;
        return selectedDateTime === offerStartDateTime || selectedDateTime === offerEndDateTime;
    }

    static getRTOConfirmationText(startDate: Date | null, endDate: Date | null, vacationDays: Date[] | null): string {
        const startDateTime = RtoDatesHelpers.convertToTimestamp(startDate);
        const endDateTime = RtoDatesHelpers.convertToTimestamp(endDate);
        if (!startDate || !endDate || !vacationDays?.length) {
            return '';
        }
        const isDateSelected = (dateTime: number) =>
            vacationDays.some((date) => RtoDatesHelpers.convertToTimestamp(date) === dateTime);

        const isStartDateSelected = isDateSelected(startDateTime);
        const isEndDateSelected = isDateSelected(endDateTime);
        const dateFormat = 'MM/DD/YYYY';

        const formattedStartDate = dayjs(startDate).format(dateFormat);
        const formattedEndDate = dayjs(endDate).format(dateFormat);

        if (isStartDateSelected && isEndDateSelected) {
            return ` And I approve the dates selected on <b>Day1: ${formattedStartDate} and End of Contract: ${formattedEndDate}</b>`;
        }
        if (isStartDateSelected) {
            return ` And I approve the dates selected on <b>Day1: ${formattedStartDate}</b>`;
        }
        if (isEndDateSelected) {
            return ` And I approve the dates selected on <b>End of Contract:${formattedEndDate}</b>`;
        }
        return '';
    }
}
